import request from "@/plugin/axios";
//查询币种列表
export function getCurrList(data) {
  return request({
    url: "/getCurrList",
    method: "post",
    data: data
  });
}
//新增币种
export function addCurrData(data) {
  return request({
    url: "/addCurrData",
    method: "post",
    data: data
  });
}
//删除币种
export function delCurrData(data) {
  return request({
    url: "/delCurrData",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询收汇方式列表
export function getPaymentMode(data) {
  return request({
    url: "/getPaymentMode",
    method: "post",
    data: data
  });
}
//新增收汇方式
export function addPaymentData(data) {
  return request({
    url: "/addPaymentData",
    method: "post",
    data: data
  });
}
//删除收汇方式
export function delPaymentData(data) {
  return request({
    url: "/delPaymentData",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询价格术语
export function getPriceTerm(data) {
  return request({
    url: "/getPriceTerm",
    method: "post",
    data: data
  });
}
//新增价格术语
export function addPriceTerm(data) {
  return request({
    url: "/addPriceTerm",
    method: "post",
    data: data
  });
}
//删除价格术语
export function delPriceTerm(data) {
  return request({
    url: "/delPriceTerm",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询国家
export function getCountry(data) {
  return request({
    url: "/getCountry",
    method: "post",
    data: data
  });
}
//新增国家
export function addCountry(data) {
  return request({
    url: "/addCountry",
    method: "post",
    data: data
  });
}
//删除国家
export function delCountry(data) {
  return request({
    url: "/delCountry",
    method: "post",
    data: data
  });
}
//递归国家
export function recursionCountry(data) {
  return request({
    url: "/recursionCountry",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询贸易方式
export function getTradeMode(data) {
  return request({
    url: "/getTradeMode",
    method: "post",
    data: data
  });
}
//新增贸易方式
export function addTradeMode(data) {
  return request({
    url: "/addTradeMode",
    method: "post",
    data: data
  });
}
//删除贸易方式
export function delTradeMode(data) {
  return request({
    url: "/delTradeMode",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询计量单位
export function getUnit(data) {
  return request({
    url: "/getUnit",
    method: "post",
    data: data
  });
}
//新增计量单位
export function addUnit(data) {
  return request({
    url: "/addUnit",
    method: "post",
    data: data
  });
}
//删除计量单位
export function delUnit(data) {
  return request({
    url: "/delUnit",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询运输方式
export function getShippingMode(data) {
  return request({
    url: "/getShippingMode",
    method: "post",
    data: data
  });
}
//新增运输方式
export function addShippingMode(data) {
  return request({
    url: "/addShippingMode",
    method: "post",
    data: data
  });
}

//删除运输方式
export function delShippingMode(data) {
  return request({
    url: "/delShippingMode",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询省份
export function getProvince(data) {
  return request({
    url: "/getProvince",
    method: "post",
    data: data
  });
}
//新增省份
export function addProvince(data) {
  return request({
    url: "/addProvince",
    method: "post",
    data: data
  });
}
//删除省份
export function delProvince(data) {
  return request({
    url: "/delProvince",
    method: "post",
    data: data
  });
}

//---------------------------------------------------------------------------------------------------------
//查询港口
export function getPort(data) {
  return request({
    url: "/getPort",
    method: "post",
    data: data
  });
}
//---------------------------------------------------------------------------------------------------------
//查询海关编码
export function getCIQ(data) {
  return request({
    url: "/getCIQ",
    method: "post",
    data: data
  });
}
//查询快件公司
export function getExpress(data) {
  return request({
    url: "/getExpress",
    method: "post",
    data: data
  });
}
//查询船公司
export function getShipCompany(data) {
  return request({
    url: "/getShipCompany",
    method: "post",
    data: data
  });
}
//查询代货公司
export function getAgent(data) {
  return request({
    url: "/getAgent",
    method: "post",
    data: data
  });
}
//查询仓库信息
export function getZQStorage(data) {
  return request({
    url: "/getZQStorage",
    method: "post",
    data: data
  });
}
//查询费用维护
export function getCostItem(data) {
  return request({
    url: "/getCostItem",
    method: "post",
    data: data
  });
}
//供应商级别
export function getClientLevel1(data) {
  return request({
    url: "/getClientLevel1",
    method: "post",
    data: data
  });
}
//客户级别
export function getClientLevel(data) {
  return request({
    url: "/getClientLevel",
    method: "post",
    data: data
  });
}

//---------------------------------------------------------------------------------------------------------
//查询业务员
export function getSalesman(data) {
  return request({
    url: "/getSalesman",
    method: "post",
    data: data
  });
}
//查询公司详情
export function getCompany(data) {
  return request({
    url: "/getCompany",
    method: "post",
    data: data
  });
}
//查询供应商详情
export function getClient1(data) {
  return request({
    url: "/getClient1",
    method: "post",
    data: data
  });
}

//查询User表生成的树
export function getZQUserTree(data) {
  return request({
    url: "/getZQUserTree",
    method: "post",
    data: data
  });
}
//测试类
export function getZQUserListTree(data) {
  return request({
    url: "/getZQUserListTree",
    method: "post",
    data: data
  });
}
//厂区类
export function getStorage(data) {
  return request({
    url: "/getStorage",
    method: "post",
    data: data
  });
}

//查询客户列表
export function getZQClientList(data) {
  return request({
    url: "/getZQClientList",
    method: "post",
    data: data
  });
}

//查询客户和供应商列表
export function getVendorsCustomers(data) {
  return request({
    url: "/getVendorsCustomers",
    method: "post",
    data: data
  });
}
//查询供应商列表
export function getSupplierList(data) {
  return request({
    url: "/getSupplierList",
    method: "post",
    data: data
  });
}

//查询快递公司列表
export function getExpressList(data) {
  return request({
    url: "/getExpressList",
    method: "post",
    data: data
  });
}
//根据clientCode 查询指定客户或供应商
export function getCodeClient(data) {
  return request({
    url: "/getCodeClient",
    method: "post",
    data: data
  });
}
//客户分类递归树
export function getClientTree(data) {
  return request({
    url: "/getClientTree",
    method: "post",
    data: data
  });
}
//客户分类列表
export function getClientSelect(data) {
  return request({
    url: "/getClientSelect",
    method: "post",
    data: data
  });
}
//客户分类列表
export function getClientSource(data) {
  return request({
    url: "/getClientSource",
    method: "post",
    data: data
  });
}
//该人详细信息
export function getUserDataDet(data) {
  return request({
    url: "/getUserDataDet",
    method: "post",
    data: data
  });
}
//供应商分类
export function getClient1Select(data) {
  return request({
    url: "/getClient1Select",
    method: "post",
    data: data
  });
}
//供应商来源
export function getClientSource1(data) {
  return request({
    url: "/getClientSource1",
    method: "post",
    data: data
  });
}

//查询工序
export function getGongXu(data) {
  return request({
    url: "/getGongXu",
    method: "post",
    data: data
  });
}
//新增工序
export function addGongXu(data) {
  return request({
    url: "/addGongXu",
    method: "post",
    data: data
  });
}
//工序库列表
export function getProduct1(data) {
  return request({
    url: "/getProduct1",
    method: "post",
    data: data
  });
}
//工序库商品列表
export function getProduct1UserCostGX(data) {
  return request({
    url: "/getProduct1UserCostGX",
    method: "post",
    data: data
  });
}
//工序库商品列表
export function editProduct1(data) {
  return request({
    url: "/editProduct1",
    method: "post",
    data: data
  });
}
//判断工序库产品
export function jugeProduct1UserCostGX(data) {
  return request({
    url: "/jugeProduct1UserCostGX",
    method: "post",
    data: data
  });
}

//新增工序库
export function addProduct1(data) {
  return request({
    url: "/addProduct1",
    method: "post",
    data: data
  });
}
//
export function getClient1Tree(data) {
  return request({
    url: "/getClient1Tree",
    method: "post",
    data: data
  });
}
//修改默认语言
export function UserLangService(data) {
  return request({
    url: "/UserLangService",
    method: "post",
    data: data
  });
}
//查语言列表
export function getLanguageListY(data) {
  return request({
    url: "/getLanguageListY",
    method: "post",
    data: data
  });
}
//修改语言列表
export function saveDataLanguageY(data) {
  return request({
    url: "/saveDataLanguageY",
    method: "post",
    data: data
  });
}
